import { PluginImportConfigDataStreamStep } from 'pages/datasources/components/customImport/PluginImportConfigDataStreamStep';
import { EditorSteps } from 'ui/editor/dataStream/TileEditor/constants';
import type { DataStreamFilters } from 'ui/editor/dataStream/TileEditor/hooks/useDataStreamFilters';
import type { StepWithCondition } from 'ui/editor/dataStream/TileEditor/hooks/useTileEditorSteps';
import { DataStreamDisplayName } from 'ui/editor/dataStream/TileEditor/steps/stepDefinitions/dataStreamStep/DataStreamDisplayName';

interface PluginImportConfigDataStreamStepProps {
    dataStreamFilters: DataStreamFilters;
    pluginId: string;
}

interface UsePluginImportDataStreamStepParameters {
    isLoading: boolean;
    dataStreamFilters: DataStreamFilters;
    pluginId: string;
}

/**
 * Create an object representing a plugin import data stream step.
 */
export const usePluginImportDataStreamStep = ({
    isLoading,
    dataStreamFilters,
    pluginId
}: UsePluginImportDataStreamStepParameters): StepWithCondition<
    Record<string, unknown>,
    PluginImportConfigDataStreamStepProps
> => {
    const isEnabled = !isLoading;

    return {
        name: EditorSteps.dataStream,
        isEnabled,
        Sublabel: DataStreamDisplayName,
        sublabelProps: {},
        Content: PluginImportConfigDataStreamStep,
        contentProps: {
            dataStreamFilters,
            pluginId
        }
    };
};
